define(["jquery",
    "site/TEKsystems.SitecoreXP.LazyLoad",
    "site/TEKsystems.SitecoreXP.BtnFocus",
    "site/TEKsystems.SitecoreXP.JumpNav",
    "site/TEKsystems.SitecoreXP.JumpNavFF", 
    "site/TEKsystems.SitecoreXP.JumpNavVNN",
    "site/TEKsystems.SitecoreXP.HeaderNav",
    "site/TEKsystems.SitecoreXP.FacetPanels", 
    "site/TEKsystems.SitecoreXP.Animations",
    "site/TEKsystems.SitecoreXP.StickyHeader",
    "site/TEKsystems.SitecoreXP.eventForms", 
    "site/TEKsystems.SitecoreXP.DisclaimerModalLightBox",
    "site/TEKsystems.SitecoreXP.VideoModalLightBoxScoreClose",
    "site/TEKsystems.SitecoreXP.ScoreSearch",
    "site/TEKsystems.SitecoreXP.GsapAnimations",
    "site/TEKsystems.SitecoreXP.Scroll",
    "site/TEKsystems.SitecoreXP.CollapsiblePanel",
    "site/TEKsystems.SitecoreXP.VideoHero",
    "site/TEKsystems.SitecoreXP.InvisibleReCaptcha"],
    function ($,
        lazyLoad,
        btnFocus,
        jumpNav,
        jumpNavFF,
        jumpNavVNN,
        headerNav,
        facetPanels,
        tekanimate,
        stickyHeader,
        eventForms,
        disclaimerMod,
        vidscoremodlightclose,
        scoreSearch,
        gsapAnimations,
        scroll,
        collapsiblePanel,
        videoHero,
        invisibleReCaptcha) {

        function run() {

            var isInExperienceEditor = isPageEditor();
            /*----- Refactored Code for Easier Bug Finding -----*/
            lazyLoad.Init();// from TEKsystems.SitecoreXP.LazyLoad.js
            btnFocus.Init(); //from TEKsystems.SitecoreXP.BtnFocus.js
            headerNav.Init(); // from TEKsystems.SitecoreXP.HeaderNav.js
            stickyHeader.Init(); // from TEKsystems.SitecoreXP.StickyHeader.js
            facetPanels.Init(); // from TEKsystems.SitecoreXP.FacetPanels.js
            jumpNav.Init(); // from TEKsystems.SitecoreXP.JumpNav.js
            jumpNavFF.Init(); // from TEKsystems.SitecoreXP.JumpNavFF.js
            jumpNavVNN.Init(); // from TEKsystems.SitecoreXP.JumpNavVNN.js
            tekanimate.Init(); // from TEKsystems.SitecoreXP.Animations.js
            gsapAnimations.Init(isInExperienceEditor); // from TEKsystems.SitecoreXP.GsapAnimations.js
            eventForms.Init(); // from TEKsystems.SitecoreXP.eventForms.js
            disclaimerMod.Init(); // from TEKsystems.SitecoreXP.DisclaimerModalLightBox.js
            vidscoremodlightclose.Init(); // from TEKsystems.SitecoreXP.VideoModalLightBoxScoreClose.js
            scoreSearch.Init(); // from TEKsystems.SitecoreXP.ScoreSearch.js
            scroll.Init();// from TEKsystems.SitecoreXP.Scroll.js
            collapsiblePanel.Init();// from TEKsystems.SitecoreXP.CollapsiblePanel.js
            videoHero.Init();// from TEKsystems.SitecoreXP.VideoHero.js
            invisibleReCaptcha.Init();// from TEKsystems.SitecoreXP.InvisibleReCaptcha.js
        }

        function isPageEditor() {
            return (!!((typeof Sitecore !== "undefined") && (typeof Sitecore.PageModes !== "undefined") && (typeof Sitecore.PageModes.PageEditor !== "undefined")) || (document.body && document.body.getAttribute("class") === "sc-edit-mode"));
        }

        /* Add any new functions specific to this project here */

        return {
            run: run
        };
    });